import { Card, Stack } from '@mui/material';
import { CardContent } from '@occc/ui-design-system';
import { Flow_Types } from '@occc-app/offerHelpers/types';
import { CampaignComponentFooterActions } from '@occc-app/routes/CampaignComponents/components/CampaignComponentFooterActions';
import { CampaignComponentReadOnlyFooterActions } from '@occc-app/routes/CampaignComponents/components/CampaignComponentReadOnlyFooterActions';

import { FormLayout } from '@occc-app/routes/CampaignComponents/components/FormLayout';
import {
  LocationInStateConstraint,
  StoreLocationOrGroupsConstraint,
  SubBrandConstraint,
} from '@occc/feat-constraints';
import { TargetFormValues } from '../../types';

type TargetFormContentProps = {
  isReadOnlyRole: boolean;
  currentFlowType: Flow_Types;
  submitting?: boolean;
  dirty?: boolean;
  handleNextButtonClick: () => void;
  values: TargetFormValues;
  shouldShowSubBrands?: boolean;
  handleCancel?: () => void;
  isLoading?: boolean;
};

export const TargetFormContent = ({
  isReadOnlyRole,
  currentFlowType,
  submitting = false,
  dirty = false,
  handleNextButtonClick,
  values,
  shouldShowSubBrands = false,
  handleCancel,
  isLoading,
}: TargetFormContentProps) => {
  const formFooterActionButtons = isReadOnlyRole ? (
    <CampaignComponentReadOnlyFooterActions
      onCancel={handleCancel ?? (() => {})}
      onNextStepClick={handleNextButtonClick}
    />
  ) : (
    <CampaignComponentFooterActions
      currentFlowType={currentFlowType}
      onCancel={handleCancel ?? (() => {})}
      isSubmitDisabled={submitting || (currentFlowType === Flow_Types.Update && !dirty)}
    />
  );

  return (
    <FormLayout actions={formFooterActionButtons} type='primary' isLoading={isLoading}>
      <Card>
        <CardContent>
          <Stack spacing={3}>
            <LocationInStateConstraint />
            <StoreLocationOrGroupsConstraint type={values.storeLocationOrGroups.type} />
            {shouldShowSubBrands && <SubBrandConstraint />}
          </Stack>
        </CardContent>
      </Card>
    </FormLayout>
  );
};
